function hasOneTrustLoaded() {
    return typeof window.OnetrustActiveGroups === 'string';
}

function waitForOneTrust() {
    if (hasOneTrustLoaded()) {
        optanonWrapper();
        window.OptanonWrapper = optanonWrapper;
        return;
    }
    
    let attempts = 0;
    const interval = setInterval(function () {
        attempts++;
        if (hasOneTrustLoaded()) {
            clearInterval(interval);
            optanonWrapper();
            window.OptanonWrapper = optanonWrapper;
        } else if (attempts > 100) {
            clearInterval(interval);
        }
    }, 100);
}

function sendConsent(trackingConsent) {
	window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, () => {
		console.log("Shopify Consent Captured")
		//To reload a page once consent is updated by the user
		document.querySelectorAll('.save-preference-btn-handler.onetrust-close-btn-handler, #onetrust-accept-btn-handler, #onetrust-reject-all-handler, #accept-recommended-btn-handler').forEach(el => {
			el.addEventListener('click', function () {
				window.location.reload();
			});
		});
	});
}

function youtubeConsent(iframe) {
	// Get all elements with the specified class
	var consentElements = document.getElementsByClassName('consent-video-btn');
	// Check if any elements were found
	while (consentElements.length > 0) {
		// Remove the first element with the specified class
		consentElements[0].remove();
	}

	// Get the div elements by their class name
	const consentDivs = document.getElementsByClassName('consent-thumb');
	// Loop through the divs and set their display property to "block"
	for (let i = 0; i < consentDivs.length; i++) {
		consentDivs[i].style.display = 'block';
	}
}

function optanonWrapper() 
{
   
	performanceConsent = !!window.OnetrustActiveGroups.includes('C0002');
	functionalConsent = !!window.OnetrustActiveGroups.includes('C0003');
	targetingConsent = !!window.OnetrustActiveGroups.includes('C0004');
	const trackingConsent = { analytics: performanceConsent, marketing: targetingConsent, preferences: functionalConsent, sale_of_data: false };
	window.Shopify.loadFeatures(
		[
			{
				name: 'consent-tracking-api',
				version: '0.1',
			},
		],
		error => {
			if (error) {
				console.error('Shopify consent tracking API error:', error);
				return;
			}
			sendConsent(trackingConsent)

			if (trackingConsent.analytics == false) {
				//Ensure that Shopify Cookie is Deleted.
				purgeShopifyCookie('_shopify_sa_p');
				purgeShopifyCookie('_shopify_sa_t');
				purgeShopifyCookie('_shopify_s');
				purgeShopifyCookie('_shopify_y');
				purgeShopifyCookie('_y');
				purgeShopifyCookie('_fbp');

				//Ensure existing klaviyo cookie is deleted
				purgeShopifyCookie('__kla_id');
				document.cookie = "__kla_off=true";
			} else {
				purgeShopifyCookie('__kla_off');
			}

		},
	);
	if (!window.OnetrustActiveGroups.includes('C0002') || !window.OnetrustActiveGroups.includes('C0003') || !window.OnetrustActiveGroups.includes('C0004') || !window.OnetrustActiveGroups.includes('C0005')) {
		let iframes = document.getElementsByTagName("iframe");
		for (var i = 0; i < iframes.length; i++) {
			let src = iframes[i].getAttribute('data-src');
			if (src && src.includes("www.youtube.com")) {
				youtubeConsent(iframes[i]);
			}
		}
	}
}

(function () {
	// Loop through the divs and set their display property to "none"
	// Get the div elements by their class name
	const consentDiv = document.getElementsByClassName('consent-thumb');
	for (let i = 0; i < consentDiv.length; i++) {
		consentDiv[i].style.display = 'none';
	}
	waitForOneTrust();
})();


/**
 * Purges a Shopify cookie by name.
 * @param {string} name - The name of the cookie to purge.
 */
function purgeShopifyCookie(name) {
    document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = name + '=; path=/; domain=' + window.location.hostname + '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
